import { useState } from "react";
import { KeyRound } from "lucide-react";
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { api, apiError } from "@/lib/api";
import { RideCard } from "@/components/fleet/RideCard";

export const InviteUnlockDialog = ({ code, onClose, onBook, onUnlock }) => {
  const [pin, setPin] = useState("");
  const [ride, setRide] = useState(null);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const unlock = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    try {
      const { data } = await api.post(`/invites/${code}/unlock`, { pin });
      setRide(data);
    } catch (err) {
      setError(apiError(err, "PIN non valido"));
    } finally {
      setLoading(false);
    }
  };

  return (
    <Dialog open={!!code} onOpenChange={(o) => !o && onClose()}>
      <DialogContent data-testid="invite-unlock-dialog" className="ff-glass-panel sm:max-w-md max-h-[92vh] overflow-y-auto rounded-2xl p-5 sm:p-7">
        <DialogHeader className="text-left">
          <DialogTitle className="ff-display text-2xl font-extrabold flex items-center gap-2"><KeyRound size={22} className="text-[#3B82F6]" /> Corsa riservata</DialogTitle>
          <DialogDescription className="text-[#94A3B8] text-sm">Un collega ti ha invitato. Inserisci il PIN ricevuto per vedere la corsa.</DialogDescription>
        </DialogHeader>
        {ride ? (
          <RideCard ride={ride} hideShare onBook={(r) => onBook(r, pin)} onUnlock={onUnlock} />
        ) : (
          <form onSubmit={unlock} className="flex flex-col gap-3">
            <input data-testid="invite-pin-input" className="ff-field ff-code text-center text-2xl tracking-[0.5em]" inputMode="numeric" maxLength={6} placeholder="••••••" value={pin} onChange={(e) => setPin(e.target.value.replace(/\D/g, ""))} />
            {error && <p data-testid="invite-pin-error" className="text-sm text-red-400">{error}</p>}
            <button type="submit" data-testid="invite-unlock-button" disabled={pin.length < 6 || loading} className="ff-btn-primary w-full uppercase text-base">
              {loading ? "Verifica…" : "Sblocca corsa"}
            </button>
          </form>
        )}
      </DialogContent>
    </Dialog>
  );
};
